module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marian Babson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marian Babson, born Ruth Stenstreem, is an American mystery writer. Her first published work was "), _c('I', [_vm._v("Cover-Up Story")]), _vm._v(" (1971), and she has written over forty-five mysteries. Babson served as secretary of the Crime Writers’ Association and was awarded the CWA Dagger in the Library in 1996."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CJtpRA/tc-custom/9781504059831.jpg?1706796567547",
      "alt": "This image is the cover for the book Only the Cat Knows"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Only the Cat Knows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A man infiltrates a tycoon’s castle to find out who pushed his sister down a flight of stairs in this “enjoyable Gothic mystery that keeps you guessing” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Vance is an experienced female impersonator, so when his beloved twin sister, Vanessa, winds up in a coma after a suspicious fall, he has a unique way to investigate. Using her clothes and makeup—and his striking resemblance to his twin—he works his way into the remote castle of Vanessa’s wealthy employer, along with a harem of other women. With help from a doctor, Vance poses as an amnesiac Vanessa and is able to fool everyone—with the exception of his sister’s Angora cat. But will his masquerade be successful long enough for him to solve the mystery—before someone else tries to finish the job?"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Diverting . . . will keep readers’ attention.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Marian Babson’s name on a mystery is a guarantee of quality writing wrapped around an unusual crime.” —"), _c('i', [_vm._v("Houston Chronicle")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0